module.exports = __webpack_public_path__ + "static/barbarawork3-df1d9b0399e1abb81cc214d1dd8b9884.jpg";